// src/app/dev/dev.routes.ts
import { Routes } from '@angular/router';
import { isDevMode } from '@angular/core';

export const DEV_ROUTES: Routes = [
	{
		path: 'ui-kit',
		canMatch: [() => isDevMode()],
		loadComponent: () => import('./ui-kit/ui-kit.component').then(m => m.UiKitComponent)
	}
];